<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="tarfFactForm">
        <v-layout row wrap>
          <v-flex row xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.scheme}}</v-subheader>
            <div class="title">{{this.$store.state.parameters.scheme.schemeMenu.sideMenuTitle}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.planNo}}</v-subheader>
            <div class="title">{{this.ids.planNo}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.busCls}}</v-subheader>
            <div class="title">{{this.ids.busCls}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.tarf}}</v-subheader>
            <div class="title">{{this.ids.tarf}}</div>
          </v-flex>
          <v-flex xs6 v-if="!newFact">
            <v-subheader class="queryLabel">{{labels.seqNo}}</v-subheader>
            <div class="title">{{tarfFactForm.seqNo}}</div>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field data-vv-scope="tarfFactForm" v-model="tarfFactForm.seqNo" :label="labels.seqNo" :error-messages="errors.collect('tarfFactForm.seqNo')" data-vv-name="seqNo" :data-vv-as="labels.seqNo" v-validate="'required|numeric|max:10'"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <!-- space -->
          </v-flex>
          <v-flex xs6 v-if="!newFact">
            <cal-picker data-vv-scope = "tarfFactForm" :label="labels.effDate" v-model="tarfFactForm.effDate" :error-messages="errors.collect('tarfFactForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'" readonly></cal-picker>
          </v-flex>
          <v-flex xs6 v-else>
            <cal-picker data-vv-scope = "tarfFactForm" :label="labels.effDate" v-model="tarfFactForm.effDate" :error-messages="errors.collect('tarfFactForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'"></cal-picker>
          </v-flex>
          <v-flex xs6>
            <cal-picker data-vv-scope = "tarfFactForm" :label="labels.expDate" v-model="tarfFactForm.expDate" :error-messages="errors.collect('tarfFactForm.expDate')" data-vv-name="expDate" :data-vv-as="labels.expDate" :min="tarfFactForm.effDate"></cal-picker>
          </v-flex>
          <v-flex xs6>
            <v-layout column wrap align-content-start>
              <v-flex xs6>
                <v-autocomplete data-vv-scope="tarfFactForm" :items="factStringList" v-model="tarfFactForm.fact1" :label="labels.fact1" item-text="label" item-value="value" :error-messages="errors.collect('tarfFactForm.fact1')" data-vv-name="fact1" :data-vv-as="labels.fact1" clearable></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete data-vv-scope="tarfFactForm" :items="factStringList" v-model="tarfFactForm.fact2" :label="labels.fact2" item-text="label" item-value="value" :error-messages="errors.collect('tarfFactForm.fact2')" data-vv-name="fact2" :data-vv-as="labels.fact2" clearable></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete data-vv-scope="tarfFactForm" :items="factStringList" v-model="tarfFactForm.fact3" :label="labels.fact3" item-text="label" item-value="value" :error-messages="errors.collect('tarfFactForm.fact3')" data-vv-name="fact3" :data-vv-as="labels.fact3" clearable></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs6>
            <v-layout column wrap align-content-start>
              <v-flex xs6>
                <v-autocomplete data-vv-scope="tarfFactForm" :items="factNumList" v-model="tarfFactForm.fact4" :label="labels.fact4" item-text="label" item-value="value" :error-messages="errors.collect('tarfFactForm.fact4')" data-vv-name="fact4" :data-vv-as="labels.fact4" clearable></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete data-vv-scope="tarfFactForm" :items="factNumList" v-model="tarfFactForm.fact5" :label="labels.fact5" item-text="label" item-value="value" :error-messages="errors.collect('tarfFactForm.fact5')" data-vv-name="fact5" :data-vv-as="labels.fact5" clearable></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete data-vv-scope="tarfFactForm" :items="factNumList" v-model="tarfFactForm.fact6" :label="labels.fact6" item-text="label" item-value="value" :error-messages="errors.collect('tarfFactForm.fact6')" data-vv-name="fact6" :data-vv-as="labels.fact6" clearable></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSaveTarfFactForm">
        {{newFact ? 'Save Factor' : 'Update Factor'}}
        <v-icon right>{{newFact ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import FieldMixin from '@/mixins/field'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { FACTORLIST_SET } from '@/store/types'
export default {
  data() {
    return {
      tarfFactForm: {
        scheme: null,
        planNo: null,
        busCls: null,
        tarf: null,
        benefit: null,
        seqNo: null,
        effDate: null,
        expDate: null,
        description: null,
        fact1: null,
        fact2: null,
        fact3: null,
        fact4: null,
        fact5: null,
        fact6: null
      },
      labels: {
        scheme: 'Scheme',
        planNo: 'Plan No',
        busCls: 'Business Class',
        tarf: 'Tariff',
        seqNo: 'Sequence*',
        effDate: 'Effective Date*',
        expDate: 'Expired Date',
        description: 'Factor Description*',
        fact1: 'Factor 1',
        fact2: 'Factor 2',
        fact3: 'Factor 3',
        fact4: 'Factor 4',
        fact5: 'Factor 5',
        fact6: 'Factor 6'
      },
      loading: false,
      submitting: false,
      newFact: null,
      factNumList: [],
      factStringList: []
    }
  },
  watch: {
    'ids.seqNo': function(value) {
      this.tarfFactForm.scheme = this.ids.scheme
      this.tarfFactForm.planNo = this.ids.planNo
      this.tarfFactForm.busCls = this.ids.busCls
      this.tarfFactForm.tarf = this.ids.tarf
      this.tarfFactForm.benefit = this.ids.benefit
      Promise.all([this.doFactorInit()])
      if (value !== 'new') {
        this.tarfFactForm.seqNo = this.ids.seqNo
        this.resetValidator()
        this.resetMessages()
        this.newFact = false
        if (value != null) {
          this.fetchForm(value)
        }
      } else {
        this.newFact = true
        this.doClearForm()
      }
    }
  },
  computed: {
    pkgTarfBenMenu() {
      return this.$store.state.parameters.scheme.pkgTarfBenMenu
    }
  },
  methods: {
    async fetchForm(seqNo) {
      const apiURI = this.pkgTarfBenMenu.menu.pkgTarfFact
      if (apiURI) {
        try {
          const expand = {
            scheme: this.ids.scheme,
            planNo: this.ids.planNo,
            busCls: this.ids.busCls,
            tarf: this.ids.tarf,
            benefit: this.ids.benefit,
            seqNo: seqNo,
            effDate: this.ids.factEffDate
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.tarfFactForm.scheme = this.ids.scheme
            this.tarfFactForm.planNo = this.ids.planNo
            this.tarfFactForm.busCls = this.ids.busCls
            this.tarfFactForm.tarf = this.ids.tarf
            this.tarfFactForm.benefit = this.ids.benefit
            this.tarfFactForm.seqNo = data.pkgTarfFact.seqNo
            this.tarfFactForm.effDate = data.pkgTarfFact.effDate
            this.tarfFactForm.expDate = data.pkgTarfFact.expDate
            this.tarfFactForm.fact1 = this.isNullFactor(data.pkgTarfFact.fact1)
            this.tarfFactForm.fact2 = this.isNullFactor(data.pkgTarfFact.fact2)
            this.tarfFactForm.fact3 = this.isNullFactor(data.pkgTarfFact.fact3)
            this.tarfFactForm.fact4 = this.isNullFactor(data.pkgTarfFact.fact4)
            this.tarfFactForm.fact5 = this.isNullFactor(data.pkgTarfFact.fact5)
            this.tarfFactForm.fact6 = this.isNullFactor(data.pkgTarfFact.fact6)

            // extract Menu
            this.menu = extractMenu(result.data._links)
            const factor = {
              fact1: this.isNullFactor(data.pkgTarfFact.fact1),
              fact2: this.isNullFactor(data.pkgTarfFact.fact2),
              fact3: this.isNullFactor(data.pkgTarfFact.fact3),
              fact4: this.isNullFactor(data.pkgTarfFact.fact4),
              fact5: this.isNullFactor(data.pkgTarfFact.fact5),
              fact6: this.isNullFactor(data.pkgTarfFact.fact6)
            }
            this.ids.rateEffDate = null
            this.$store.commit(FACTORLIST_SET, factor)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Tariff Factor Form')
      }
    },
    doSaveTarfFactForm() {
      this.resetMessages()
      this.$validator.validateAll('tarfFactForm').then(result => {
        if (result) {
          if (this.newFact) {
            this.doCreateTarfFactForm()
          } else {
            this.doUpdateTarfFactForm()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.tarfFactForm.scheme = this.ids.scheme
      this.tarfFactForm.planNo = this.ids.planNo
      this.tarfFactForm.busCls = this.ids.busCls
      this.tarfFactForm.tarf = this.ids.tarf
      this.tarfFactForm.benefit = this.ids.benefit
      this.tarfFactForm.seqNo = null
      this.tarfFactForm.effDate = null
      this.tarfFactForm.expDate = null
      this.tarfFactForm.fact1 = null
      this.tarfFactForm.fact2 = null
      this.tarfFactForm.fact3 = null
      this.tarfFactForm.fact4 = null
      this.tarfFactForm.fact5 = null
      this.tarfFactForm.fact6 = null
    },
    async doCreateTarfFactForm() {
      const apiURI = this.pkgTarfBenMenu.menu.pkgTarfFactCreate
      if (apiURI) {
        try {
          const formatForm = {
            scheme: this.tarfFactForm.scheme,
            planNo: this.tarfFactForm.planNo,
            busCls: this.tarfFactForm.busCls,
            tarf: this.tarfFactForm.tarf,
            benefit: this.tarfFactForm.benefit,
            seqNo: this.tarfFactForm.seqNo,
            effDate: this.tarfFactForm.effDate,
            expDate: this.tarfFactForm.expDate,
            fact1: this.isNullFactor(this.tarfFactForm.fact1),
            fact2: this.isNullFactor(this.tarfFactForm.fact2),
            fact3: this.isNullFactor(this.tarfFactForm.fact3),
            fact4: this.isNullFactor(this.tarfFactForm.fact4),
            fact5: this.isNullFactor(this.tarfFactForm.fact5),
            fact6: this.isNullFactor(this.tarfFactForm.fact6)
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClearForm()
            this.$emit('resetTab', 2)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    async doUpdateTarfFactForm() {
      const apiURI = this.menu.pkgTarfFactUpdate
      if (apiURI) {
        try {
          const formatForm = {
            scheme: this.tarfFactForm.scheme,
            planNo: this.tarfFactForm.planNo,
            busCls: this.tarfFactForm.busCls,
            tarf: this.tarfFactForm.tarf,
            benefit: this.tarfFactForm.benefit,
            seqNo: this.tarfFactForm.seqNo,
            effDate: this.tarfFactForm.effDate,
            expDate: this.tarfFactForm.expDate,
            fact1: this.isNullFactor(this.tarfFactForm.fact1),
            fact2: this.isNullFactor(this.tarfFactForm.fact2),
            fact3: this.isNullFactor(this.tarfFactForm.fact3),
            fact4: this.isNullFactor(this.tarfFactForm.fact4),
            fact5: this.isNullFactor(this.tarfFactForm.fact5),
            fact6: this.isNullFactor(this.tarfFactForm.fact6)
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            const factor = {
              fact1: this.tarfFactForm.fact1,
              fact2: this.tarfFactForm.fact2,
              fact3: this.tarfFactForm.fact3,
              fact4: this.tarfFactForm.fact4,
              fact5: this.tarfFactForm.fact5,
              fact6: this.tarfFactForm.fact6
            }
            this.$store.commit(FACTORLIST_SET, factor)
            this.fetchForm(this.ids.seqNo)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    isNullFactor(value) {
      if (typeof value === 'undefined') {
        return null
      } else {
        return value
      }
    },
    async doFactorInit() {
      const apiURI = this.pkgTarfBenMenu.menu.factorList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            if (this.factNumList > 0) {
              this.factNumList = []
            }
            if (this.factStringList > 0) {
              this.factStringList = []
            }
            this.factStringList = data.factStringList
            this.factNumList = data.factNumList
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - factor List')
      }
    }
  },
  props: {
    ids: {
      type: Object,
      default () {
        return {
          busCls: null,
          tarf: null,
          benefit: null,
          factEffDate: null
        }
      }
    }
  },
  mixins: [
    FieldMixin,
    MessageMixin
  ]
}
</script>

<style>

</style>
